module.exports = __webpack_public_path__ + "media/pick_axe02.cd221ed0.mp3";